import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {IWifiConnectionInfo} from '../../../../../services/AngularServices/WifiAnalyzerService';
import {
    router,
    fullWifi,
    smallWifi,
    link,
    smallTethering,
    locked,
    location,
    podcast,
    controllerDevice,
    cellTower,
    satelliteAltOutlined
} from '../../icons';
import {ITranslate} from '../../../../../services/LocalizationService';
import {observer} from 'mobx-react';

interface ConnectedNetworkBoxProps {
    connection: IWifiConnectionInfo;
    getDbmColor: (dbm: number | undefined) => string;
    translate: ITranslate;
}

@observer
export class ConnectedNetworkBox extends TechseeBaseComponent<ConnectedNetworkBoxProps> {
    renderInternal() {
        const {connection, getDbmColor, translate} = this.props;

        return (
            <div className='tab-box active'>
                <div className='tab-box-icons-and-description'>
                    <div className={'icon'}>{router}</div>
                    <span>{`${translate('CONNECTIVITY_GURU.WIFI_SCAN.ACCESS_POINT')} ${connection.macAddress}`}</span>
                </div>

                <div className={`tab-box-icons-and-description ${getDbmColor(connection.rssi)}`}>
                    <div className={'icon'}>{fullWifi}</div>
                    <span> {translate('CONNECTIVITY_GURU.WIFI_SCAN.RSSI')} (%) </span>
                    <span>{connection.signalStrengthPercentage}%</span>
                </div>

                <div className='tab-box-icons-and-description'>
                    <div className={'icon'}>{smallWifi}</div>
                    <span> {translate('CONNECTIVITY_GURU.WIFI_SCAN.RSSI_LEVEL')} </span>
                    <span className='bold-text'>{connection.rssi} dBm</span>
                </div>

                <div className='divider' />

                {connection.channel && (
                    <div className='tab-box-icons-and-description'>
                        <div className={'icon'}>{smallTethering}</div>
                        <span> {translate('CONNECTIVITY_GURU.WIFI_SCAN.CHANNEL')} </span>
                        <span className='bold-text'>{connection.channel}</span>
                    </div>
                )}

                <div className='tab-box-icons-and-description'>
                    <div className={'icon'}>{satelliteAltOutlined}</div>
                    <span> {translate('CONNECTIVITY_GURU.WIFI_SCAN.FREQUENCY')} </span>
                    <span className='bold-text'>{connection.frequency ?? '2.4 GHz'}</span>
                </div>

                <div className='divider' />

                <div className='tab-box-icons-and-description'>
                    <div className={'icon'}>{locked}</div>
                    <span> {translate('CONNECTIVITY_GURU.WIFI_SCAN.SECURITY')} </span>
                    <span className='bold-text'>{connection.security || 'N/A'}</span>
                </div>

                <div
                    className={`tab-box-icons-and-description ${connection?.txLinkSpeedMbps > 0 && connection?.rxLinkSpeedMbps > 0 ? '' : 'margin-b-0'}`}>
                    <div className={'icon'}>{location}</div>
                    <span> {translate('CONNECTIVITY_GURU.WIFI_SCAN.DISTANCE')} </span>
                    <span className='bold-text'>
                        {connection.distanceMeters ? `${connection.distanceMeters.toFixed(1)}m` : 'N/A'}
                    </span>
                </div>

                {connection?.txLinkSpeedMbps > 0 && connection?.rxLinkSpeedMbps > 0 && (
                    <div className='tab-box-icons-and-description margin-b-0'>
                        <div className={'icon'}>{podcast}</div>
                        <span> TR/RX </span>
                        <span className='bold-text'>
                            {connection?.txLinkSpeedMbps} Mbps / {connection?.rxLinkSpeedMbps} Mbps
                        </span>
                    </div>
                )}
            </div>
        );
    }
}
